<template>
    <div id="title-bar">
        <div class='title f-between'>
        <div class="flex webname" @click="gotomenu('/home')"><img src="../assets/img/logo.png"></div>
        <div class="menu" v-if="name!=''">
            <div class="flex menuitem"  @click="gotomenu('/info')" >采录记录</div>
            <div class="flex menuitem"  @click="gotomenu('/score')" >积分记录</div>
            <div class="flex menuitem"  @click="gotomenu('/user')"  >用户列表</div>
        
        </div>
        
        
        </div>

    </div>
</template>

<script>

    export default {
        name: 'titleBar',
        data() {
            return {
                name:""

            }
        },
        created() {
            this.name = localStorage.getItem('name') || ''
  

        },
        methods:{

            gotomenu(path) {

                this.$router.push(path)
            }

        }
    }
</script>
    
<style>
#title-bar {
    z-index:999;
    position: fixed;
    width: 100%;
    height: 64px;
    background-color: #413b79;
    -webkit-app-region: drag;
    border-bottom:1px transparent solid;
    border-image:linear-gradient(to right,#FFCCCC,#413b79) 1 10;
}

.title-btn {
    color: #848484 !important;
    border-radius: 5px;
    line-height:28px !important;
    position:absolute;
    width: 24px;
    height: 24px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    -webkit-app-region: no-drag;
}

.title-btn.close {
    right: 20px;
    background-color:#ff2d2d52;
}

.title-btn.close:hover {
    background-color:#ff2d2d;
}

.title-btn.min {
    right: 60px;
    background-color:#ffe63652;
}

.title-btn.min:hover {
    background-color:#ffe636;
}

.title{
    line-height: 64px;
    color: white;
    margin: 0 20px;
}

.webname
{
    float: left;
    width: 200px !important;
}

.menu
{
    float: left;
    width: 400px !important;
}

.menuitem
{
    float: left;
    width: 100px !important;
    cursor: pointer;
}

.menuitem:hover
{
    color: red;
}

</style>